@app.directive 'csradiostateparam', ($filter, $state, csConfig) ->
  restrict: 'E',
  scope: { paramName: "@", choices: "="},
  templateUrl: "/assets/templates/directives/csRadioStateParam/csRadioStateParam.html"

  link: ($scope) ->
    $scope.$state = $state

    $scope.goState = (choice) ->
      newState = angular.extend({}, $state.params)
      newState[$scope.paramName] = choice
      $state.go '.', newState



